import { render, staticRenderFns } from "./IndicatorsView.vue?vue&type=template&id=7ded652f&scoped=true&"
import script from "./IndicatorsView.vue?vue&type=script&lang=js&"
export * from "./IndicatorsView.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorsView.vue?vue&type=style&index=0&id=7ded652f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ded652f",
  null
  
)

export default component.exports